import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/adherent`;
const token = localStorage.getItem("token");

///GET
// Fonction pour récupérer les adhérents avec leur groupe
export const getAllAdherentsWithGroup = async () => {
  try {
    const response = await axios.get(`${apiUrl}/getAllAdherentsWithGroup`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des adhérents :", error);
    return null;
  }
};

// Fonction pour compter le nombre d'adhérents
export const countAdherents = async () => {
  try {
    const response = await axios.get(`${apiUrl}/countadherents`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du comptage des adhérents :", error);
  }
};

// Fonction pour récupérer les adhérents d'un club
export const getAllAdherentsByClub = async (clubId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getAllAdherentsByClub/${clubId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des adhérents :", error);
    return null;
  }
};

// Fonction pour récupérer les adhérents d'un groupe
export const getAdherentsByGroup = async (groupId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getAdherentsByGroup/${groupId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des adhérents :", error);
    return null;
  }
};

/// POST
// Fonction pour ajouter un adhérent
export const addAdherent = async (adherentData) => {
  try {
    const response = await axios.post(`${apiUrl}/addAdherent`, adherentData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'adhérent :", error);
    return null;
  }
};

// Fonction pour ajouter un adhérent à un groupe
export const addAdherentToGroup = async (groupId, adherentData) => {
  try {
    const response = await axios.post(
      `${apiUrl}/addAdherentToGroup/${groupId}`,
      adherentData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'adhérent au groupe :", error);
    return null;
  }
};

export const uploadAdherentsFile = async (groupId, file) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("❌ Token manquant !");
      return;
    }

    console.log(
      "📡 Envoi du fichier à :",
      `${apiUrl}/upload-adherents/${groupId}`
    );
    console.log("🔑 Token envoyé :", token);

    const formData = new FormData();
    formData.append("adherentsFile", file);

    const response = await axios.post(
      `${apiUrl}/upload-adherents/${groupId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("✅ Réponse de l'API :", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "🚨 Erreur lors de l'upload du fichier d'adhérents:",
      error.response?.data || error
    );
    throw error;
  }
};

/// PUT
// Fonction pour modifier un adhérent
export const updateAdherent = async (adherentId, adherentData) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateAdherent/${adherentId}`,
      adherentData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification de l'adhérent :", error);
    return null;
  }
};

///DELETE
// Fonction pour supprimer un adhérent
export const deleteAdherent = async (adherentId) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/deleteAdherent/${adherentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de l'adhérent :", error);
    return null;
  }
};

// Fonction pour supprimer un adhérent d'un groupe
export const deleteAdherentFromGroup = async (adherentId, groupId) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/deleteAdherentFromGroup/${adherentId}/${groupId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la suppression de l'adhérent du groupe :",
      error
    );
    return null;
  }
};
